// ContractMenu.js
import React, { useState } from 'react';
import { Text } from '../../Atoms';

const ContractMenu = ({ onMenuChange }) => {
  const [activeMenu, setActiveMenu] = useState('echeancier');

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    onMenuChange(menu); // Call the prop function to notify the parent
  };

  return (
    <div className="contract-menu">
      {['echeancier', 'beneficiaires', 'documents', 'mes_garanties'].map(
        (menu) => (
          <div
            key={menu}
            className={`contract-menu-item ${
              activeMenu === menu ? 'active' : ''
            }`}
            onClick={() => handleMenuClick(menu)}
          >
            <Text
              className="contract-title"
              text={
                menu.charAt(0).toUpperCase() + menu.slice(1).replace(/_/g, ' ')
              }
            />
          </div>
        )
      )}
    </div>
  );
};

export default ContractMenu;
